import React from 'react'
import { useRef, useState } from "react";
import { Overlay, Tooltip } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import { TextWrap } from "../../util/showmore";
import { CallControls } from "./CallControls";
import { CallMenuList } from "./CallMenuList";
import * as constants from "./constants";
import CustomInfo from "./CustomInfo";
import { GetAgentPhotoOrInitial } from "./helpers";
import { actionTypes } from "./reducer";
import { Timer } from "./Timer";

export function LiveCall(props) {
  const [minimizeCallTicker, setMinimizeCallTicker] = useState(false);
  const [show, setShow] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const target = useRef(null);
  const { callFlow } = props;

  const window_state = useSelector((state) => {
    return state.ticker.window_state;
  });

  const dispatch = useDispatch();

  const setViewState = (view_state) => {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: { view_state: view_state },
    });
  };

  const handleMinimize = () => {
    setMinimizeCallTicker(true);
    dispatch({
      type: actionTypes.onCallViewState,
      payload: { window_state: constants.C2C_CONSTANTS.WINDOW_STATE_MINIMIZED },
    });
  };

  const handleMaximize = () => {
    setMinimizeCallTicker(false);
    dispatch({
      type: actionTypes.onCallViewState,
      payload: { window_state: constants.C2C_CONSTANTS.WINDOW_STATE_OPENED },
    });
  };

  const copyToClipboard = () => {
    try {
      if (!target.current) return;
      const textToCopy = target.current.textContent;
      navigator && navigator.clipboard.writeText(textToCopy).then(() => {
        setShow(true);
        setTimeout(() => { setShow(false); }, 1000);
      }).catch((error) => {
        setErrorMsg('Error copying to clipboard: ' + error);
        setShow(true);
        setTimeout(() => { setShow(false); }, 2000);
      });
    } catch (error) {
      console.log("Failure in Copy to clipboard", error);
    }
  };

  return (
    <>
      <div
        className={
          "tmodal tmodal-dialog-scrollable call-ticker-dialog-sec " +
          (minimizeCallTicker ? "minimizedd" : "")
        }
      >
        <div className="tmodal-content" style={{ height: "100%" }}>
          {window_state == constants.C2C_CONSTANTS.WINDOW_STATE_MINIMIZED ? (
            <div className="d-flex justify-content-between align-items-center live-call-header minimize">
              <div className="header-content">
                <div className="number-sec">
                  <div className="head-sec-title">SR Number:</div>
                  <div className="head-sec-detail">
                    {props.callFlow.getSRNumber()}
                  </div>
                </div>
                <div className="quick-detail-sec">
                  <span className="voice-indicator">
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/sr/icons/voice-indicator.svg")}
                    />
                  </span>
                  <span className="call-timer-min">
                    <Timer disableSymbols={true} />
                  </span>
                </div>
                {props.callFlow.hasQueue() && props.callFlow.getQueueName() && (
                  <div className="queue-sec">
                    <div className="head-sec-title">Queue:</div>
                    <div className="head-sec-detail">
                      <TextWrap
                        text={props.callFlow.getQueueName()}
                        max={props.isMobile ? 10 : 12}
                        placement="top"
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="click-icon" onClick2={handleMaximize}>
                <a
                  href="/#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleMaximize();
                  }}
                  onClick2={() => {
                    setViewState(constants.CALL_VIEW_STATES.CALL_VIEW);
                  }}
                >
                  <img
                    alt=""
                    className="header-close-icon"
                    src={toAbsoluteUrl("/media/sr/icons/ticker-maximize.svg")}
                  />
                </a>
              </div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-center  live-call-header">
                <div className="header-content">
                  <div className="number-sec">
                    <div className="head-sec-title">SR Number:</div>
                    <div className="head-sec-detail">
                      {props.callFlow.getSRNumber()}
                    </div>
                  </div>

                  {props.callFlow.hasQueue() && props.callFlow.getQueueName() && (
                    <div className="queue-sec">
                      <div className="head-sec-title">Queue:</div>
                      <div className="head-sec-detail">
                        <TextWrap
                          text={props.callFlow.getQueueName()}
                          max={props.isMobile ? 10 : 12}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="click-icon" onClick={handleMinimize}>
                  <img
                    alt=""
                    className="header-close-icon"
                    src={toAbsoluteUrl("/media/sr/icons/ticker-minimize.svg")}
                  />
                </div>
              </div>
              <div className="py-7 px-5">
                <div className="live-call-section">
                  <div className="row justify-content-center ">
                    <div className="user-photo-sec ">
                      <GetAgentPhotoOrInitial
                        agent={{
                          first_name: callFlow.getCustomerName(),
                          last_name: null,
                        }}
                        wrapCls="user-photo"
                        imgCls="user-photo-icon"
                      />
                      {/**<div className="user-photo">
                                                     <img
                                                     alt="" className="user-photo-icon" 
                                                    src={toAbsoluteUrl("/media/sr/icons/dummy-face.svg")} />
                                                </div>**/}
                    </div>
                  </div>
                  <div className="call-detail-sec">
                    <div className="row justify-content-center">
                      <div className="call-timer">
                        <Timer disableSymbols={true} />
                      </div>
                    </div>

                    <div className="row justify-content-center" ref={target}
                      style={{ cursor: 'pointer', zIndex: 9999 }} draggable="false" onClick={copyToClipboard}>
                      <div className="call-number" style={{ marginRight: 5 }}>
                        {props.callFlow.getCustomerNumber()}
                      </div>
                      <Overlay target={target.current} show={show} placement="top">
                        {(props) => (<Tooltip id="overlay-example" {...props}>{errorMsg ? errorMsg : 'Copied to clipboard.'}</Tooltip>)}
                      </Overlay>
                      <div>
                        <img
                          alt="copy-icon"
                          className="copy-icn"
                          draggable="false"
                          style={{ cursor: 'pointer', padding: '9px 6px' }}
                          src={toAbsoluteUrl("/media/sr/icons/crm/copy.svg")}
                        />
                      </div>
                    </div>
                    <div className="row justify-content-center">
                      <div className="caller-name">
                        <TextWrap
                          text={props.callFlow.getCustomerName()}
                          max={20}
                        />
                        {callFlow.state.callInitialEvent &&
                          callFlow.state.callInitialEvent
                            .variable_sticky_agent === "1" && (
                            <span className="ml-1">
                              <img
                                alt=""
                                style={{
                                  verticalAlign: "top",
                                  borderStyle: "none",
                                  height: "22px",
                                  marginTop: "-4px",
                                }}
                                className="sticky-ag "
                                src={toAbsoluteUrl(
                                  "/media/sr/icons/sticky-agent.svg"
                                )}
                              />
                            </span>
                          )}
                      </div>
                    </div>
                    <CustomInfo obj={props.callFlow.state.callEvent} />

                    <CallControls callFlow={callFlow} />
                  </div>
                  <CallMenuList callFlow={callFlow} />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
